// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/input-number/style/index.less
// module id = 1099
// module chunks = 1